import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { BreadcrumbService } from 'xng-breadcrumb';

@Component({
  selector: 'app-amenity-create',
  template: `
    <div class="row">
      <div class="col-sm-12 offset-sm-0 col-lg-9 offset-lg-3 mt-5">
      <xng-breadcrumb ></xng-breadcrumb>
        <div class="row mb-4 mt-4">
          <div class="col-md-9">
            <h1>Amenidad</h1>
            <p>Configura las amenidades que están disponibles para los departamentos.</p>
          </div>
          <div class="col-md-3 text-end mt-4">
            
          </div>
        </div>
        <div class="row">
          <div class="col-md-7">
            <div class="card border-0 rounded-4 shadow">
              <div class="card-body p-4">
                <div class="row">
                  <div class="col-md-12">
                    <h4>Agregar amenidad</h4>
                    <p>Configura la amenidad con los siguientes campos.</p>
                    <app-form-amenity (amenityData)="createAmenity($event)" [loading]="loading"></app-form-amenity>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class AmenityCreateComponent implements OnInit {

  loading: boolean = false;

  constructor(
    private store: SettlementsService,
    private toastr: ToastrService,
    private router: Router,
    private breadcrumbService: BreadcrumbService,
  ) { }

  ngOnInit(): void {
    this.breadcrumbService.set('@createAmenity', 'Crear role');
  }

  createAmenity(event: any) {
    this.store.createAmenity(event).subscribe({
      next: (data: any) => {
        console.log(data);
        this.toastr.success('Servicio creado correctamente.');
        this.router.navigate(['/amenities']);
      },
      error: (err: any) => {
        console.log(err);
        this.toastr.error('Ocurrió un error al crear el servicio.');
      }
    });
  }

}
